import React from 'react';
import { getCredentialingPracticePanelSummary } from 'api/credentialing';
import type { TPanelStatusSummary } from 'types/credentialing';

const INIT: TPanelStatusSummary = { actionNeeded: 0, inProgress: 0, approved: 0, live: 0 };
let globalData: TPanelStatusSummary = INIT;

const usePracticePanelSummary = (enabled = true): [TPanelStatusSummary, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<TPanelStatusSummary>(globalData);

    const fetchData = React.useCallback(async () => {
        setLoading(true);
        try {
            const result = await getCredentialingPracticePanelSummary();
            if (!result.error) {
                const summary: TPanelStatusSummary = result?.data?.data || INIT;
                globalData = summary;
                setData(summary);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    React.useEffect(() => {
        if (enabled) fetchData();
    }, [fetchData, enabled]);

    return [data, loading, fetchData];
};

export default usePracticePanelSummary;
